// Opens the SightMap calcualtor control on click

SPACES.CalculatorTrigger = (function ($) {
  function CalculatorTrigger () {
    this.$controlElement = $('[data-spaces-control="unit-calculator-trigger"]')
  }

  CalculatorTrigger.prototype.init = function () {
    const control = this

    control.$controlElement.each(function () {
      $trigger = $(this)

      $trigger.on('click', function (e) {
        e.preventDefault();

        if($(this).hasClass('spaces-disabled')) {
          return false
        }

        $(this).addClass('spaces-disabled')

        const unitNumber= $(this).data('spaces-unit-number')
        SPACES.utility.log(`recieved calculator click event for unit: ${unitNumber} unit-calculator-trigger.js:24`)

				const selectedTerm = $(this).attr('data-spaces-calculator-lease-term')
				const selectedDate = $(this).attr('data-spaces-calculator-date')

        $('[data-spaces-control="calculator-frame"]').prop('src', `${SPACES.spacesConfig.sightmap_url}?unit_number=${unitNumber}&lease_term=${selectedTerm}&move_in_date=${selectedDate}&mode=expense_calculator`)
        SPACES.spacesModal.open('[data-spaces-control="calculator"]')

        $(this).removeClass('spaces-disabled')
      })
    })
  }

  return CalculatorTrigger
})(jQuery)

document.addEventListener('spaces_init', function (e) {
  // Hook into the main SPACES init
  SPACES.calculatorTrigger = new SPACES.CalculatorTrigger()
  SPACES.calculatorTrigger.init()
})

document.addEventListener('spaces_tab', function (e) {
  // Run init after AJAX tab switch
  SPACES.calculatorTrigger = new SPACES.CalculatorTrigger()
  SPACES.calculatorTrigger.init()
})
